import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface SocialAdminState {
  // Date range filters
  dateFrom: string;
  dateTo: string;
  setDateFrom: (dateFrom: string) => void;
  setDateTo: (dateTo: string) => void;
  setDateRange: (dateFrom: string, dateTo: string) => void;
  
  // Sorting
  sortBy: 'title' | 'views';
  sortOrder: 'asc' | 'desc';
  setSortBy: (sortBy: 'title' | 'views') => void;
  setSortOrder: (sortOrder: 'asc' | 'desc') => void;
  
  // Search
  search: string;
  setSearch: (search: string) => void;
  
  // Reset all filters
  resetFilters: () => void;
}

export const useSocialAdminStore = create<SocialAdminState>()(
  persist(
    (set) => ({
      dateFrom: '',
      dateTo: '',
      sortBy: 'views',
      sortOrder: 'desc',
      search: '',
      
      setDateFrom: (dateFrom: string) => set({ dateFrom }),
      setDateTo: (dateTo: string) => set({ dateTo }),
      setDateRange: (dateFrom: string, dateTo: string) => set({ dateFrom, dateTo }),
      setSortBy: (sortBy: 'title' | 'views') => set({ sortBy }),
      setSortOrder: (sortOrder: 'asc' | 'desc') => set({ sortOrder }),
      setSearch: (search: string) => set({ search }),
      
      resetFilters: () => set({
        dateFrom: '',
        dateTo: '',
        sortBy: 'views',
        sortOrder: 'desc',
        search: '',
      }),
    }),
    {
      name: 'social-admin-filters',
      version: 3, // bump version to reset stored state
    }
  )
);

